/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResourceStateEnum,
    ResourceStateEnumFromJSON,
    ResourceStateEnumFromJSONTyped,
    ResourceStateEnumToJSON,
    ResourceType,
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    serial?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    description?: string;
    /**
     * 
     * @type {ResourceType}
     * @memberof Resource
     */
    type?: ResourceType;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    longitude?: number;
    /**
     * 
     * @type {ResourceStateEnum}
     * @memberof Resource
     */
    currentState?: ResourceStateEnum;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    currentPlan?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    topic?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    hasBackup?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    hostId?: number;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    houseId?: number;
}

export function ResourceFromJSON(json: any): Resource {
    return ResourceFromJSONTyped(json, false);
}

export function ResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Resource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'serial': !exists(json, 'serial') ? undefined : json['serial'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : ResourceTypeFromJSON(json['type']),
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'currentState': !exists(json, 'current_state') ? undefined : ResourceStateEnumFromJSON(json['current_state']),
        'currentPlan': !exists(json, 'current_plan') ? undefined : json['current_plan'],
        'topic': !exists(json, 'topic') ? undefined : json['topic'],
        'hasBackup': !exists(json, 'has_backup') ? undefined : json['has_backup'],
        'hostId': !exists(json, 'host_id') ? undefined : json['host_id'],
        'houseId': !exists(json, 'house_id') ? undefined : json['house_id'],
    };
}

export function ResourceToJSON(value?: Resource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'serial': value.serial,
        'description': value.description,
        'type': ResourceTypeToJSON(value.type),
        'latitude': value.latitude,
        'longitude': value.longitude,
        'current_state': ResourceStateEnumToJSON(value.currentState),
        'current_plan': value.currentPlan,
        'topic': value.topic,
        'has_backup': value.hasBackup,
        'host_id': value.hostId,
        'house_id': value.houseId,
    };
}

